import {FullTableMap, OutputTableMap} from 'notebook/tables/excess/EvaluationConstants';
import lazyInit from 'util/lazyInit';

class SpreadsheetEvalCache {
  cachedTableMapByFileId: {[fileId: string]: FullTableMap};
  cachedComputedTablesByFileId: {[fileId: string]: OutputTableMap};

  constructor() {
    this.cachedTableMapByFileId = {};
    this.cachedComputedTablesByFileId = {};
  }

  setValues(fileId: string, tableMap: FullTableMap, computedTables: OutputTableMap): void {
    this.cachedTableMapByFileId[fileId] = tableMap;
    this.cachedComputedTablesByFileId[fileId] = computedTables;
  }

  getCachedTableMap(fileId: string): FullTableMap | undefined {
    return this.cachedTableMapByFileId[fileId];
  }

  getCachedComputedTables(fileId: string): OutputTableMap | undefined {
    return this.cachedComputedTablesByFileId[fileId];
  }

  evictValues(fileId: string): void {
    delete this.cachedTableMapByFileId[fileId];
    delete this.cachedComputedTablesByFileId[fileId];
  }
}

export const getSpreadsheetEvalCache = lazyInit(() => new SpreadsheetEvalCache());
